// Standardized Color Palette for BookAPT
// Alternative to Blue/Green color scheme

export const Colors = {
  // Primary Actions (Main CTAs)
  primary: '#2563EB', // Professional blue (similar to LinkedIn/PayPal) - Trustworthy and professional
  primaryLight: '#3B82F6',
  primaryDark: '#1E40AF',
  
  // Secondary Actions (Supporting actions)
  secondary: '#14B8A6', // Teal/Cyan - Fresh and friendly
  secondaryLight: '#5EEAD4',
  secondaryDark: '#0D9488',
  
  // Success/Positive Actions
  success: '#10B981', // Emerald - Success states
  successLight: '#34D399',
  successDark: '#059669',
  
  // Neutral Actions (Cancel, Ghost buttons)
  neutral: '#6B7280', // Gray - Neutral actions
  neutralLight: '#9CA3AF',
  neutralDark: '#4B5563',
  
  // Warning/Important Actions
  warning: '#F59E0B', // Amber - Important actions
  warningLight: '#FBBF24',
  warningDark: '#D97706',
  
  // Background Colors
  background: '#F8F9FA',
  backgroundLight: '#FFFFFF',
  backgroundDark: '#F3F4F6',
  
  // Text Colors
  textPrimary: '#1C1C1E',
  textSecondary: '#6B7280',
  textTertiary: '#9CA3AF',
  textWhite: '#FFFFFF',

  /** Placeholder text in TextInput fields (web + native). */
  inputPlaceholder: '#94a3b8',
  
  // Border Colors
  border: '#E5E7EB',
  borderLight: '#F3F4F6',
  borderDark: '#D1D5DB',
  
  // Error/Destructive
  error: '#EF4444', // Red
  errorLight: '#F87171',
  errorDark: '#DC2626',
};

/** Shared placeholder color for raw TextInput fields. */
export const INPUT_PLACEHOLDER_COLOR = Colors.inputPlaceholder;

// Button Style Constants
export const ButtonSizes = {
  small: {
    fontSize: 12,
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRadius: 6,
  },
  medium: {
    fontSize: 14,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
  },
  large: {
    fontSize: 16,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
  },
  extraLarge: {
    fontSize: 18,
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderRadius: 12,
  },
};

// Quick Action Card Style
export const QuickActionCard = {
  backgroundColor: Colors.backgroundLight,
  borderWidth: 1,
  borderColor: Colors.border,
  borderRadius: 12,
  paddingVertical: 16,
  paddingHorizontal: 12,
  fontSize: 13,
  fontWeight: '600' as const,
  color: Colors.textPrimary,
  minHeight: 100,
};

